import { render, staticRenderFns } from "./HomeStaffCard.vue?vue&type=template&id=7ff1a582&"
import script from "./HomeStaffCard.vue?vue&type=script&lang=js&"
export * from "./HomeStaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports